import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {URLSearchParams} from "@angular/http";
import {Page} from "../domain/page";
import {MailTemplate} from "../domain/mailTemplate";

/**
 * .
 * Created by jlado on 13/9/16.
 */
@Injectable()
export class MailTemplateService {

    constructor(private backendService: ObservableBackendService) {
    }

    public findMailTemplates(filter: MailTemplate, page: number, itemsPerPage: number): Observable<Page> {
        let params = new URLSearchParams();
        if (filter.action && filter.action.id) {
            params.set('action.id', filter.action.id);
        }
        if (filter.bank && filter.bank.id) {
            params.set('bank.id', filter.bank.id);
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("mailTemplates", params);
    }

    public getMailTemplate(mailTemplateId: string): Observable<MailTemplate> {
        return this.backendService.get("mailTemplate/" + mailTemplateId, null);
    }

    public save(mailTemplate: MailTemplate): Observable<MailTemplate> {
        return mailTemplate.id != null
            ? this.backendService.post("mailTemplate", mailTemplate, null)
            : this.backendService.put("mailTemplate", mailTemplate, null);
    }

    public delete(mailTemplateId: string): Observable<MailTemplate> {
        return this.backendService.delete("mailTemplate/" + mailTemplateId, null, null);
    }

    public previewMailTemplate(mailTemplateBody: string): Observable<MailTemplate> {
        return this.backendService.post("previewMailTemplate", mailTemplateBody, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/mailTemplate.service.ts
 **/